import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import IconDelete from '@mui/icons-material/Delete';
import style from './index.module.scss';
import clsx from 'clsx';
import { useTranslate } from 'hooks/use-translate';

interface Props extends IconButtonProps {}
export const ButtonDelete: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const { t } = useTranslate();

  return (
    <IconButton
      title={t('delete')}
      children={<IconDelete color={'inherit'} />}
      {...props}
      className={clsx(style.root, props.className)}
    />
  );
};
